<div class="p-(--padding-card)">
  <ces-route-title [count]="choiceLists.length">
    <ces-button [label]="'common.buttons.add' | transloco" icon="add" (onClick)="createChoiceList()" />
  </ces-route-title>

  <ces-generic-parent-grid
    (createChildEntity)="createElement($event)"
    (createEntity)="createChoiceList()"
    (deleteChildEntity)="deleteElement($event)"
    (deleteEntity)="deleteChoiceList($event)"
    (editChildEntity)="editElement($event)"
    (editEntity)="editChoiceList($event)"
    [childEntities]="elementsByList"
    [dataLoadingCompleted]="dataLoadingCompleted"
    [entities]="choiceLists"
    [entityDefinition]="choiceListDefinition" />
</div>
